import styled from 'styled-components';
import Config from '@config';
import Skeleton from '@atoms/Skeleton/Skeleton';
import { rem } from 'polished';

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(16)};
`;

export const SkeletonBreadcrumbs = styled(Skeleton)`
  margin-bottom: ${rem(24)};

  ${Config.MEDIA.FROM_DESKTOP} {
    margin: ${rem(24)};
  }
`;

export const SkeletonContent = styled.div<{ $isPage?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $isPage }) => ($isPage ? rem(32) : 0)};

  ${Config.MEDIA.FROM_DESKTOP} {
    flex-direction: row;
  }
`;

export const SkeletonImage = styled(Skeleton)<{ $isPage?: boolean }>`
  width: 100%;
  height: ${rem(320)};
  margin: 0;

  ${Config.MEDIA.FROM_DESKTOP} {
    width: ${({ $isPage }) => ($isPage ? rem(416) : rem(320))};
    margin: ${({ $isPage }) => ($isPage ? `${rem(40)} ${rem(24)}` : rem(24))};
    height: ${rem(600)};
  }
`;

export const SkeletonDetails = styled.div<{ $isPage?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: ${rem(16)};

  ${Config.MEDIA.FROM_DESKTOP} {
    margin: ${({ $isPage }) => ($isPage ? `${rem(40)} ${rem(24)}` : rem(24))};
  }
`;

export const SkeletonInfo = styled(Skeleton)`
  margin-top: ${rem(16)};
  margin-bottom: ${rem(48)};
`;

export const SkeletonTitle = styled(Skeleton)<{ $isPage?: boolean }>`
  margin-top: ${({ $isPage }) => ($isPage ? 0 : rem(18))};
`;

export const SkeletonTabs = styled(Skeleton)<{ $isPage?: boolean }>`
  margin-top: ${rem(50)};
  height: ${rem(128)};

  ${Config.MEDIA.FROM_DESKTOP} {
    height: ${({ $isPage }) => ($isPage ? rem(360) : rem(320))};
  }
`;
